<script type="text/jsx">
import BallLoader from 'ui/v1/loaders/BallLoader.vue';

export default {
    functional: true,
    render(h, { data }) {
        const classes = [
            'loader-box flex flex-1 flex-col h-full w-full items-center justify-center',
            data.class,
            data.staticClass,
        ];
        return <div class={classes}><BallLoader></BallLoader></div>;
    },
};
</script>
